import Model from '@/store/plugins/orm/Model'
import Store from '@/store';

export class TaxRate extends Model {
    static get entity () {
        return 'tax_rates'
    }

    static get TYPE_PRODUCT() {
        return 'product';
    }

    static get TYPE_ORDER() {
        return 'order';
    }

    static get TYPE_TAX_ON_NET() {
        return 'TaxOnNet';
    }

    static get TYPE_TAX_ON_TOTAL() {
        return 'TaxOnTotal';
    }

    static get TYPE_AMONT_PER_QUANTITY() {
        return 'AmountPerQuantity';
    }

    static get TYPES() {
        return [
            TaxRate.TYPE_PRODUCT,
            TaxRate.TYPE_ORDER,
            TaxRate.TYPE_TAX_ON_NET,
            TaxRate.TYPE_TAX_ON_TOTAL,
            TaxRate.TYPE_AMONT_PER_QUANTITY,
        ];
    }

    static fields () {
        return {
            id: this.attr(null),
            label: this.attr(null),
            name: this.attr(null),
            type: this.attr(null),
            rate: this.attr('0.00', value => _.round(value, 2).toFixed(2)),
            locale: this.attr(null),
        }
    }

    getRate() {
        return parseFloat(this.rate);
    }

    static getZeroTaxRate() {
        if(locale === 'sr') {
            const venue = Store.getters.tenant?.venue
            if(venue && !venue.taxes_enabled) {
                return TaxRate.getTaxesDisabledTaxRate()
            }

            return TaxRate.all().find(taxRate => (taxRate.name === 'VAT' || taxRate.name === 'Без ПДВ') && taxRate.rate == 0)
        } else if(locale === 'ba') {
            return TaxRate.all().find(taxRate => taxRate.label === 'K' && taxRate.rate == 0)
        } else {
            return TaxRate.all()
                .filter(taxRate => taxRate.locale === locale)
                .find(taxRate => taxRate.rate == 0)
        }
    }

    static getTaxesDisabledTaxRate() {
        if(locale === 'sr') {
            return TaxRate.all().find(taxRate => (taxRate.name === 'VAT-EXCL' || taxRate.name === 'Није у ПДВ') && taxRate.rate == 0)
        } else if(locale === 'ba') {
            return TaxRate.all().find(taxRate => taxRate.label === 'A' && taxRate.rate == 0)
        }

        return null
    }

    static productTaxRates() {
        if(locale === 'sr') {
            return TaxRate.all().filter(taxRate => {
                return taxRate.type === TaxRate.TYPE_TAX_ON_NET
            })
        }

        if(locale === 'me') {
            return TaxRate.all().filter(taxRate => taxRate.type === TaxRate.TYPE_PRODUCT)
        }

        const taxesDisabledTaxRate = TaxRate.getTaxesDisabledTaxRate()
        if(Store.getters.tenant?.venue?.taxes_enabled) {
            return TaxRate.all().filter(taxRate => taxRate.type === TaxRate.TYPE_PRODUCT && taxRate.id !== taxesDisabledTaxRate?.id)
        }

        return taxesDisabledTaxRate?.type === TaxRate.TYPE_PRODUCT
            ? [taxesDisabledTaxRate]
            : []
    }
}

export default TaxRate
